<template>
  <div id="confirmation-view" class="confirmation-details">
    <v-container grid-list-md pt-3 pb-0>
      <v-layout wrap justify-center>
        <v-flex xs10>
          <div>
            <v-chip
              color="rgba(39, 218, 188, 0.2)"
              text-color="#27DABC"
              class="chip-title"
            >
              {{i18n('DETALHES')}}
            </v-chip>
          </div>
          <div>
            <span class="font-size-10">{{i18n('DATA')}}:</span><span class="font-size-14"> {{recordDate()}} </span><span style="font-size: 12px;">{{recordTime()}}</span>
          </div>
          <div class="pt-3">
            <v-chip
              color="rgba(39, 218, 188, 0.2)"
              text-color="#27DABC"
              class="chip-title"
            >
              {{i18n('ORIGEM')}}
            </v-chip>
          </div>
          <div>
            <span class="font-size-14">{{senderName()}}</span>
            <span class="font-size-10">
              {{senderDocumentType()}} {{senderDocumentNumber()}}
            </span>
          </div>
          <div v-if="!reverse_exchange">
            <span class="font-size-10">{{i18n('VALOR')}}:</span><span class="font-size-14"> {{originValue()}} </span><span class="font-size-10">({{originCurrency()}})</span>
          </div>
          <div v-else>
            <span class="font-size-10">{{i18n('VALOR ESTIMADO')}}<span v-if="forExchange">*</span>:</span><span class="font-size-14"> {{targetValue()}} </span><span class="font-size-10">({{originCurrency()}})</span>
            <span class="font-size-10" v-if="forExchange">{{i18n('*CONSIDERANDO CÂMBIO')}}:</span><span class="font-size-14" v-if="forExchange"> {{exchangeRate()}}</span>
          </div>
          <div><span class="font-size-10">{{fromBankAccount()}}</span></div>
          <div class="mt-3">
            <v-chip
              color="rgba(39, 218, 188, 0.2)"
              text-color="#27DABC"
              class="chip-title"
            >
              {{i18n('DESTINO')}}
            </v-chip>
          </div>
          <div>
            <span class="font-size-14">{{receiverName()}}</span>
            <span class="font-size-10">
              {{receiverDocumentType()}} {{receiverDocumentNumber()}}
            </span>
          </div>
          <div v-if="reverse_exchange">
            <span class="font-size-10">{{i18n('VALOR')}}:</span><span class="font-size-14"> {{originExchangedValue()}} </span><span class="font-size-10">({{targetCurrency()}})</span>
          </div>
          <div v-else>
            <span class="font-size-10">{{i18n('VALOR ESTIMADO')}}<span v-if="forExchange">*</span>:</span><span class="font-size-14"> {{targetValue()}} </span><span class="font-size-10">({{targetCurrency()}})</span>
            <span class="font-size-10" v-if="forExchange">{{i18n('*CONSIDERANDO CÂMBIO')}}:</span><span class="font-size-14" v-if="forExchange"> {{exchangeRate()}}</span>
          </div>
          <div><span class="font-size-10">{{toBankAccount()}}</span></div>
          <v-alert
            :value="has_error"
            type="error"
          >
            {{error_msg}}
          </v-alert>
          <div class="mt-3" v-if="forExchange">
            <v-chip
              color="rgba(39, 218, 188, 0.2)"
              text-color="#27DABC"
              class="chip-title"
            >
              {{i18n('Realizar conversão')}}
            </v-chip>
          </div>
          <div v-if="forExchange">
            <span class="font-size-14">{{exchangeUnderRequestText()}}</span>
          </div>
          <div class="mb-2"></div>
        </v-flex>
      </v-layout>
    </v-container>
    <div class="buttons-container">
      <v-btn class="default-button" color="#BCC1D1" dark @click="$emit('handle-event', {back: true})" data-testid="new-transaction-rollback-button">
        {{i18n('Voltar')}}
      </v-btn>
      <v-btn class="default-button" color="#27DABC" :loading="loading" :disabled="has_error" dark @click="loading = true, $emit('handle-event', {createTransactionAttributes: transactionAttributes})" data-testid="new-transaction-continue-button">
        <div class="icon-confirm">
          {{i18n('Prosseguir')}}
          <ion-icon name="arrow-forward" style="padding: 10px;"></ion-icon>
        </div>
      </v-btn>
    </div>
  </div>
</template>

<script>
import utils from "../../shared/Utils"
import CustomerScheduledBankTransactionDetailsCard from "../../CustomerScheduledBankTransactionDetailsCard"
export default {
  name: 'ConfirmationView',
  props: {
    context: {
      type: Object
    }
  },
  components: {
    'transaction-card': CustomerScheduledBankTransactionDetailsCard
  },
  data() {
    return {
      company: null,
      error_msg: '',
      loading: false,
      exchange_rate: {},
    }
  },
  computed: {
    transactionAttributes() {
      let transaction = {
        from_bank_account_id: this.fromBankAccountId(),
        to_bank_account_id: this.toBankAccountId(),
        currency: this.originCurrency(),
        exchange_currency: this.targetCurrency(),
        value: this.transactionValue(),
        exchanged_value: this.originExchangedValue(),
        reverse_exchange: this.context.reverse_exchange,
        subject_id: this.subjectId(),
        exchange_under_request: this.exchangeUnderRequest()
      }
      return {transaction: transaction}
    },
    senderType() {
      if (['pay', 'deposit', 'withdrawal_internal', 'exchange_internal', 'fee_payoff'].includes(this.context.selected_operation)) {
        return 'partner'
      }
      return 'subject'
    },
    senderCompany() {
      if (this.senderType == 'subject') {
        return this.context.selected_subject
      }
      return this.company
    },
    receiverCompany() {
      if (this.senderType == 'subject') {
        return this.company
      }
      return this.context.selected_subject
    },
    reverse_exchange() {
      return this.context.reverse_exchange
    },
    forExchange() {
      return !(this.originCurrency() == this.targetCurrency())
    },
    toValuePrecision() {
      return this.targetCurrency() == 'CLP' ? 0 : 2
    },
    has_error() {
      return this.error_msg.length > 0
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    subjectId() {
      return (this.context.selected_subject && this.context.selected_subject.id) || null
    },
    senderName() {
      return this.senderCompany && this.senderCompany.social_name || 'N/A'
    },
    senderDocumentType() {
      return this.senderCompany && this.senderCompany.document_type.toUpperCase() || 'N/A'
    },
    senderDocumentNumber() {
      return this.senderCompany && this.senderCompany.document_number || 'N/A'
    },
    receiverDocumentType() {
      return this.receiverCompany && this.receiverCompany.document_type.toUpperCase() || 'N/A'
    },
    receiverDocumentNumber() {
      return this.receiverCompany && this.receiverCompany.document_number || 'N/A'
    },
    receiverName() {
      return this.receiverCompany && this.receiverCompany.social_name || 'N/A'
    },
    recordDate() {
      return utils.dbDateTimeToHuman(utils.currentDateTime()).split(' ')[0]
    },
    recordTime() {
      return utils.dbDateTimeToHuman(utils.currentDateTime()).split(' ')[1]
    },
    originCurrency() {
      return this.context.selected_from_currency
    },
    targetCurrency() {
      return this.context.selected_to_currency
    },
    originValue() {
      return this.context.selected_value
    },
    originExchangedValue() {
      return this.context.selected_exchanged_value.toFixed(2)
    },
    targetValue() {
      if (!this.reverse_exchange) {
        if (this.context.selected_from_currency == this.context.selected_to_currency) {
          return this.originValue()
        }
        if (this.$root.isLocalCurrency(this.context.selected_from_currency)) {
          return (this.originValue() / Number(this.exchangeRate())).toFixed(this.toValuePrecision)
        }
        return (this.originValue() * Number(this.exchangeRate())).toFixed(this.toValuePrecision)
      }

      // reverse exchange

      if (this.context.selected_from_currency == this.context.selected_to_currency) {
        return this.originExchangedValue()
      }
      if (this.$root.isLocalCurrency(this.context.selected_from_currency)) {
        return (this.originExchangedValue() * Number(this.exchangeRate())).toFixed(2)
      }
      return (this.originExchangedValue() / Number(this.exchangeRate())).toFixed(2)
    },
    transactionValue() {
      return this.context.selected_from_currency == "CLP" ? this.context.selected_value.toFixed(0) : this.context.selected_value.toFixed(2)
    },
    exchangeRate() {
      let exchange_rate = this.context.selected_from_currency + this.context.selected_to_currency

      if (this.context.selected_from_currency == this.context.selected_to_currency) {
        return '1.00'
      }

      return this.exchange_rate[exchange_rate.toLowerCase()] && this.exchange_rate[exchange_rate.toLowerCase()].toFixed(5) || '1.00000'
    },
    fromBankAccount() {
      if (!this.context.selected_from_bank_account) {
        return 'N/A'
      }
      return utils.longAccountName(this.context.selected_from_bank_account, this.i18n)
    },
    fromBankAccountId() {
      return this.context.selected_from_bank_account && this.context.selected_from_bank_account.id || null
    },
    toBankAccount() {
      if (!this.context.selected_bank_account) {
        return 'N/A'
      }
      return utils.longAccountName(this.context.selected_bank_account, this.i18n)
    },
    toBankAccountId() {
      return this.context.selected_bank_account && this.context.selected_bank_account.id || null
    },
    exchangeUnderRequest() {
      return this.context.exchange_under_request
    },
    exchangeUnderRequestText() {
      return this.exchangeUnderRequest() ? this.i18n('FX automático') : this.i18n('FX sob demanda')
    },
    loadExchangeRate() {
      let successCallback = (response) => {
        if (response.body.data) {
          Object.keys(response.body.data).forEach((key) => {
            this.exchange_rate = {...this.exchange_rate, [key]: Number(response.body.data[key]) }
          });
        }
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
      }

      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.exchange_rates, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    }
  },
  mounted() {
    this.loadExchangeRate()
    this.$root.store.getCompany((company)=>{
      if (company) {
        this.company = company
      } else {
        this.company = {}
      }
    }, (error)=>{
      this.company = {}
    })
    this.$root.$on('error-feedback', (errors) => {
      let api_error = errors[Object.keys(errors)[0]][0]
      this.error_msg = utils.translateErrorMessage(api_error, this.$root.lang)
      this.loading = false
    })
  }
}
</script>

<style>
.confirmation-details .font-size-10 {
  font-size: 10px;
}
.confirmation-details .font-size-14 {
  font-size: 14px;
}

.confirmation-details .chip-title {
  margin: 0;
  font-size: 10px;
  border-radius: 0px;
  height: 14px;
}
.confirmation-details .chip-title .v-chip__content {
  padding-left: 7px;
  padding-right: 7px;
}
</style>




// WEBPACK FOOTER //
// src/components/NewTransaction/ConfirmationView.vue